import { Component, OnInit } from '@angular/core';
import { NgForm} from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CreateAccountModel } from 'src/app/Elearning-Models';
import { CreateAccountService } from 'src/app/services/create-account.service';
import { IServiceFactory } from 'src/app/Services/service-factory';
import { environment } from 'src/environments/environment';
import { debounceTime, switchMap } from 'rxjs/operators';
import {  Subject } from 'rxjs';

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss'],
})
export class CreateAccountComponent implements OnInit {
  createAccount: CreateAccountModel;
  passwordHide = true;
  isEdit = false;
  confirmPasswordHide = true;
  oldPasswordHide = true;
  dataService: CreateAccountService;
  originalAccountData: CreateAccountModel;
  editMode: string;
  imagePath = environment.imagePath;
  registerNewUserWait: boolean = false;

  confirmationEmailSent: boolean = false;



  private searchTerms = new Subject<string>();

  constructor(
    private toastr: ToastrService,
    private serviceFactory: IServiceFactory,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.createAccount = new CreateAccountModel();
    this.dataService = this.serviceFactory.getCreateAccountService();
  }

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe(queryParams => {
      this.editMode = queryParams.get('type');
      if (this.editMode === 'edit') {
        this.GetUserDetailsForEdit();
      } 
    });

    this.searchTerms.pipe(
      debounceTime(400), //waits 300 ms after last keyup to search again
      switchMap((term: string) => 
      this.dataService.ValidateUsername(term)
        ),)
        .subscribe( result => {
          if(!result){
            this.toastr.error("That email is already in use.");
            this.createAccount.Email = null;
          }
       });
  }

  search(term: string, email: any): void {// on keyup, the term is redfined
    if(email.errors == null){
      this.searchTerms.next(term);
    }
  }
  /**
   * This method is used to create Account.
   */
  CreateAccount = (form, data): void => {
    if (!form.valid) {
      this.toastr.warning('Please fill all required fields', 'Warning!');
      return;
    }
    if (this.checkPassword(data)) {
      this.toastr.warning('Passwords does not match', 'Warning!');
      return;
    }
    if(this.registerNewUserWait){
      return;
    }
    else{
      this.registerNewUserWait = true;
    }
    const params = {
      FirstName: data.FirstName ? data.FirstName : null,
      LastName: data.LastName ? data.LastName : null,
      Email: data.Email ? data.Email : null,
      Password: data.Password ? data.Password : null,
      PasswordConfirm: data.PasswordConfirm ? data.PasswordConfirm : null,
    };

    this.dataService.CreateAccount(params).subscribe((res) => {
      if (res) {
        form.resetForm();
        this.clearData();
        this.toastr.success('Account Created.', 'Success!');

        this.confirmationEmailSent = true;
        //window.location.reload();

        //setTimeout(() => window.location.href = '/ELearning/Curriculum', 8000);

      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
      this.registerNewUserWait = false;
    });
  };

  /**
   * This method is used to get details of user.
   */
  GetUserDetailsForEdit = (): void => {
    this.dataService.GetUserDetailsForEdit().subscribe((res) => {
      this.clearData();
      this.isEdit = true;
      this.originalAccountData = { ...res };
      this.createAccount = res;
    });
  };

  deleteParams = (params, key) => {
    return delete params[key];
  };

  /**
   * This method is used to update user data.
   */
  EditUser = (form: NgForm, data): void => {
    if (!form.valid) {
      this.toastr.warning('Please fill all required fields', 'Warning!');
      return;
    }
    if (this.checkPassword(data)) {
      this.toastr.warning('Passwords does not match', 'Warning!');
      return;
    }
    const params = {
      FirstName:
        data.FirstName != this.originalAccountData.FirstName
          ? data.FirstName
          : undefined,
      LastName:
        data.LastName != this.originalAccountData.LastName
          ? data.LastName
          : undefined,
      Email:
        data.Email != this.originalAccountData.Email ? data.Email : undefined,
      Password: data.Password ? data.Password : undefined,
      PasswordConfirm: data.PasswordConfirm ? data.PasswordConfirm : undefined,
      UserID: data.UserID ? data.UserID : undefined,
      OldPassword: data.OldPassword ? data.OldPassword : undefined,
    };
    if (data.FirstName == this.originalAccountData.FirstName) {
      this.deleteParams(params, 'FirstName');
    }
    if (data.LastName == this.originalAccountData.LastName) {
      this.deleteParams(params, 'LastName');
    }
    if (data.Email == this.originalAccountData.Email) {
      this.deleteParams(params, 'Email');
    }

    this.registerNewUserWait = true;
    this.dataService.EditUser(params).subscribe((res) => {
      if (res) {
        form.resetForm();
        this.clearData();
        this.toastr.success('Account Updated.', 'Success!');
        this.router.navigate(['/ELearning/Curriculum']);
      } else {
        this.toastr.error('Something went wrong', 'Failure!');
      }
      this.registerNewUserWait = false;
    });
  };

  /**
   * This method is used to get initial values of variables.
   */
  clearData = (): void => {
    this.createAccount = new CreateAccountModel();
    this.isEdit = false;
    this.passwordHide = true;
    this.oldPasswordHide = true;
    this.confirmPasswordHide = true;
  };

  /**
   * This method is used to compare passwords.
   */
  checkPassword = (data): boolean => {
    if (!data.PasswordConfirm) {
      return false;
    }

    if (
      data.PasswordConfirm == null ||
      data.PasswordConfirm == undefined ||
      data.Password == null ||
      data.Password == undefined
    ) {
      return false;
    }
    if (data.PasswordConfirm.length < 8 || data.Password.length < 8) {
      return false;
    }
    if (data.PasswordConfirm != data.Password) {
      return true;
    }

    return false;
  };

  EnterSubmit($event, form){
    if($event.keyCode === 13){
      !this.isEdit ? this.CreateAccount(form, this.createAccount) : this.EditUser(form, this.createAccount);
    }
  }
}
